module.exports = __webpack_public_path__ + "static/img/增值税管理云3.644ed529.png";